import { render, staticRenderFns } from "./PaymentCart.vue?vue&type=template&id=97c45c5c&"
import script from "./PaymentCart.vue?vue&type=script&lang=js&"
export * from "./PaymentCart.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCart.vue?vue&type=style&index=0&id=97c45c5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports